import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const retakeVideo = async ({ videoId }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/retake_video/${videoId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useRetakeVideoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: retakeVideo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["single_photo_session"] });
    },
    onError: (error) => {
      console.error("Failed to retake video:", error);
    },
  });
};

export default useRetakeVideoMutation;
